import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./authProvider";

const ProtectedRoute = () => {
  const { user } = useAuth();
  if (!user) {
    return <Navigate to="/login/admin" replace />;
  }
  return <Outlet />;
};

export default ProtectedRoute;
